import { Component, ViewChild } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM } from '../../../components/models';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { messages } from '../../funciones/mensajes';
import { firstValueFrom } from 'rxjs';
import { CatalogosService } from '../../../services/proyecciones/catalogos/catalogos.service';
import { CuentaContableService } from '../../../services/proyecciones/cuenta-contable/cuenta-contable.service';
import { TemplateService } from '../../../services/proyecciones/plantilla/template.service';
import { InstitucionService } from '../../../services/proyecciones/institucion/institucion.service';
import Swal from 'sweetalert2';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';

@Component({
  selector: 'app-escenarios-proyectados',
  templateUrl: './escenarios-proyectados.component.html',
  styleUrl: './escenarios-proyectados.component.css'
})
export class EscenariosProyectadosComponent {

  public Filters = FiltersM;
  public sucursales: any[] = [];
  public consolidado: boolean = true;
  public sucursalSeleccionada: string = 'Consolidado';

  public escenarios: any[] = [];
  public todosEscenarios: boolean = true;
  public escenarioSeleccionado: string = 'Escenario';

  public dataCuentaContable: any[] = [];
  public cuentasJerarquicas: any[] = [];
  public cuentasVisibles: any[] = [];
  public columnasFechas: string[] = [];
  private catTipo: any[] = [];

  public dataCargando: boolean = false;
  public selectedProjectionYear: number | undefined;

  // Nuevas propiedades para institución
  public instSelecc: any = { id: 0, alias: '' };
  private institucionId = undefined;
  private templateId = undefined;
  public inst: any[] = [];

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    public cookies: CookieService,
    private catalogo: CatalogosService,
    private cuentaContable: CuentaContableService,
    private plantillas: TemplateService,
    private instituciones: InstitucionService,
    private excelService: ExcelService
  ) {
    this.institucionId = cookies.get('idInstitucionProy');
    this.getInstituciones();
  }

  async ngOnInit() {
    this.initSucursales();
    this.initEscenarios();
    await this.getTipoCuenta();
  }

  /**
   * Elige la plantilla de la institución: primero busca 'activo' (true/'true'),
   * si no hay activa devuelve la última del array. Retorna undefined si no hay plantillas.
   */
  private pickTemplateFromInst(instItem: any): number | undefined {
    if (!instItem || !instItem.templates || instItem.templates.length === 0) return undefined;
    const active = instItem.templates.find((t: any) => t.activo === true || t.activo === 'true');
    const chosen = active || instItem.templates[instItem.templates.length - 1];
    return Number(chosen.templateid);
  }

  public async getInstituciones() {
    try {
      const res: any = await firstValueFrom(this.instituciones.getInstucionesTemplateActivo());
      this.inst = res;


      if (this.institucionId) {
        this.instSelecc = this.inst.filter((i: any) => i.institutionid == this.institucionId)[0];
        if (this.instSelecc && this.instSelecc.templates && this.instSelecc.templates.length > 0) {
          this.templateId = this.pickTemplateFromInst(this.instSelecc);
          await this.getCuentasContables();
        }
        return;
      }
      this.selectInst();
    } catch (e) {
      messages.errorMessageGraph(e);
    }
  }

  public async selectInst() {
    const instId = this.dataService.idInstitution;
    const role = this.dataService.role.toLowerCase();
    const insti = this.inst
      .filter((i: any) => i.alias !== null)
      .reduce((acc: any, item: any) => {
        acc[item.institutionid] = item.alias;
        return acc;
      }, {});

    if (role.includes('administrador')) {
      const result = await messages.confirmationSave(
        this.translate.instant('Seleccione una institución'),
        insti,
        this.translate
      );
      if (result) {
        this.instSelecc = this.inst.filter((i: any) => i.institutionid == result)[0];
        this.cookies.set('idInstitucionProy', this.instSelecc.institutionid, { path: '/' });
        this.institucionId = this.instSelecc.institutionid;

        if (this.instSelecc.templates && this.instSelecc.templates.length > 0) {
          this.templateId = this.pickTemplateFromInst(this.instSelecc);
          await this.getCuentasContables();
        }
      }
    } else {
      try {
        const res: any = await firstValueFrom(this.instituciones.getInstitucionIdAdmi(instId));
        this.instSelecc = this.inst.find((i: any) => i.institutionid == res?.[0]?.id) ?? null;

        if (this.instSelecc) {
          this.cookies.set('idInstitucionProy', this.instSelecc.institutionid, { path: '/' });
          this.institucionId = this.instSelecc.institutionid;

          if (this.instSelecc.templates && this.instSelecc.templates.length > 0) {
            this.templateId = this.pickTemplateFromInst(this.instSelecc);
            await this.getCuentasContables();
          }
        } else {
          messages.infoMessageGraph(this.translate.instant('proyFinanciera.cargaInformacion.noPlantilla'));
        }
      } catch (e) {
        messages.errorMessageGraph(e);
      }
    }
  }

  private async getTipoCuenta() {
    try {
      const res: any = await firstValueFrom(this.catalogo.getTipoCuenta());
      this.catTipo = res.map((i: any) => ({ clave: i.clavetipo, id: i.tipocuentaid }));
    } catch (e) {
      messages.errorMessageGraph(e);
    }
  }

  private generarColumnasFechas(numColumnas: number) {
    this.columnasFechas = [];
    const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    const baseYear = this.selectedProjectionYear ?? new Date().getFullYear();

    // Empezar siempre en ENE del año base y avanzar meses consecutivos
    for (let i = 0; i < numColumnas; i++) {
      const nuevaFecha = new Date(baseYear, i, 1); // i = 0 -> enero
      const mesAbrev = meses[nuevaFecha.getMonth()];
      const anio2 = String(nuevaFecha.getFullYear()).slice(-2);
      this.columnasFechas.push(`${mesAbrev} ${anio2}`);
    }
  }
  private generarValoresAleatoriosForCuentas() {
    const cols = this.columnasFechas.length || 0;
    if (!this.dataCuentaContable || this.dataCuentaContable.length === 0) return;
    for (const c of this.dataCuentaContable) {
      c.valores = [];
      for (let i = 0; i < cols; i++) {
        c.valores.push(this.generarCantidadAleatoria());
      }
    }
    // actualizar vista/jerarquía para reflejar nuevos valores
    this.organizarJerarquia();
  }

  private generarCantidadAleatoria(): string {
    const numero = Math.floor(Math.random() * 99000000) + 1000000;
    return numero.toLocaleString('es-MX');
  }

  private async getCuentasContables() {
    if (!this.templateId) {
      // Sin plantilla seleccionada: mantener el skeleton hasta que haya datos
      this.dataCargando = true;
      return;
    }

    // Mostrar skeleton mientras NO hay datos
    this.dataCargando = true;
    this.dataCuentaContable = [];
    this.columnasFechas = [];

    let loadedWithData = false;

    try {
      const numColumnas = Math.floor(Math.random() * 3) + 4;
      this.generarColumnasFechas(numColumnas);

      const res: any = await firstValueFrom(this.cuentaContable.getCuentas(this.templateId));

      // Si no vienen cuentas, limpiar las vistas y mantener el skeleton visible
      if (!res || res.length === 0) {
        this.dataCuentaContable = [];
        this.cuentasJerarquicas = [];
        this.cuentasVisibles = [];
        return; // loadedWithData sigue false -> skeleton se mantiene
      }

      // Hay datos: procesarlos y ocultar el skeleton al terminar
      if (res.length !== 0) {
        this.dataCuentaContable = [];

        for (const r of res) {
          const cuenta: any = {
            id: r.cuentaid,
            nivel: r.nivel,
            tipoCuenta: this.catTipo.find((i: any) => i.id === r.tipoid)?.clave || '',
            codigo: r.codigo,
            nombre: r.nombre,
            proyeccion: r.proyeccion,
            segmento: r.segmento,
            valores: [],
            hijos: [],
            expandido: false,
            visible: true
          };

          for (let i = 0; i < this.columnasFechas.length; i++) {
            cuenta.valores.push(this.generarCantidadAleatoria());
          }

          this.dataCuentaContable.push(cuenta);
        }
        this.organizarJerarquia();
        loadedWithData = true;
      }
    } catch (e: any) {
      messages.errorMessageGraph(e.error);
    } finally {
      // Ocultar skeleton SOLO si se cargaron datos; si no, mantener dataCargando = true hasta nueva carga
      this.dataCargando = loadedWithData ? false : true;
    }
  }

  private organizarJerarquia() {
    const cuentasOrdenadas = [...this.dataCuentaContable].sort((a, b) => {
      if (a.tipoCuenta !== b.tipoCuenta) {
        return a.tipoCuenta.localeCompare(b.tipoCuenta);
      }
      return a.codigo.localeCompare(b.codigo);
    });

    const cuentasPorTipo: any = {};

    cuentasOrdenadas.forEach((cuenta: any) => {
      if (!cuentasPorTipo[cuenta.tipoCuenta]) {
        cuentasPorTipo[cuenta.tipoCuenta] = [];
      }
      cuentasPorTipo[cuenta.tipoCuenta].push(cuenta);
    });

    this.cuentasJerarquicas = [];

    Object.keys(cuentasPorTipo).forEach((tipo: string) => {
      const cuentasTipo = cuentasPorTipo[tipo];
      const jerarquia = this.construirArbol(cuentasTipo);
      this.cuentasJerarquicas.push(...jerarquia);
    });
    this.expandirTodo();
    this.actualizarCuentasVisibles();
  }
  private expandirTodo() {
    const recorrer = (nodos: any[]) => {
      for (const nodo of nodos) {
        nodo.expandido = true;
        if (nodo.hijos && nodo.hijos.length > 0) {
          // hacer visibles los hijos directos
          nodo.hijos.forEach((h: any) => h.visible = true);
          // recursión para expandir todos los niveles
          recorrer(nodo.hijos);
        }
      }
    };

    recorrer(this.cuentasJerarquicas);
  }

  private construirArbol(cuentas: any[]): any[] {
    const nivel1 = cuentas.filter((c: any) => c.nivel === 1);

    nivel1.forEach((padre: any) => {
      padre.hijos = this.encontrarHijos(padre, cuentas);
    });

    return nivel1;
  }

  private encontrarHijos(padre: any, todasCuentas: any[]): any[] {
    const hijos = todasCuentas.filter((cuenta: any) =>
      cuenta.nivel === padre.nivel + 1 &&
      cuenta.codigo.startsWith(padre.codigo) &&
      cuenta.codigo !== padre.codigo
    );

    hijos.forEach((hijo: any) => {
      hijo.hijos = this.encontrarHijos(hijo, todasCuentas);
      hijo.visible = false;
    });

    return hijos;
  }

  private actualizarCuentasVisibles() {
    this.cuentasVisibles = [];
    this.agregarCuentasVisibles(this.cuentasJerarquicas);
  }

  private agregarCuentasVisibles(cuentas: any[]) {
    cuentas.forEach((cuenta: any) => {
      if (cuenta.visible) {
        this.cuentasVisibles.push(cuenta);

        if (cuenta.expandido && cuenta.hijos && cuenta.hijos.length > 0) {
          this.agregarCuentasVisibles(cuenta.hijos);
        }
      }
    });
  }

  public toggleExpansion(cuenta: any) {
    if (cuenta.hijos && cuenta.hijos.length > 0) {
      cuenta.expandido = !cuenta.expandido;

      cuenta.hijos.forEach((hijo: any) => {
        hijo.visible = cuenta.expandido;

        if (!cuenta.expandido && hijo.expandido) {
          this.contraerRecursivo(hijo);
        }
      });

      this.actualizarCuentasVisibles();
    }
  }

  private contraerRecursivo(cuenta: any) {
    cuenta.expandido = false;
    if (cuenta.hijos) {
      cuenta.hijos.forEach((hijo: any) => {
        hijo.visible = false;
        this.contraerRecursivo(hijo);
      });
    }
  }

  public tieneHijos(cuenta: any): boolean {
    return cuenta.hijos !== undefined && cuenta.hijos.length > 0;
  }

  public getIndentacion(cuenta: any): string {
    return `${(cuenta.nivel - 1) * 20}px`;
  }

  private initEscenarios() {
    const añoInicial = 2026;
    for (var i = 0; i < 5; i++) {
      const y = añoInicial + i;
      this.escenarios.push({
        name: `Proyecciones ${y}`,
        year: y,
        check: false
      });
    }
    this.escenarioSeleccionado = this.translate.instant('proyFinanciera.escenarioProyeccion.escenario');

  }

  private initSucursales() {
    for (var i = 0; i < 10; i++) {
      this.sucursales.push({
        name: `Sucursal-${i + 1}`,
        check: false
      });
    }

    this.sucursalSeleccionada = 'filtros.consolidado';
  }

  escenarioChange(escClick: any) {
    if (!escClick || !escClick.name) return;

    this.escenarios.forEach(e => e.check = (e.name === escClick.name));
    const seleccionado = this.escenarios.find(e => e.check);
    if (!seleccionado) {
      this.todosEscenarios = true;
      this.escenarioSeleccionado = this.translate.instant('proyFinanciera.escenarioProyeccion.escenario');
      this.selectedProjectionYear = undefined;
    } else {
      this.todosEscenarios = false;
      this.escenarioSeleccionado = seleccionado.name;
      this.selectedProjectionYear = seleccionado.year ? Number(seleccionado.year) : (/(19|20)\d{2}/.exec(seleccionado.name) ? Number((/(19|20)\d{2}/.exec(seleccionado.name) as any)[0]) : undefined);
    }

    // regenerar columnas y valores aleatorios según selección
    const cols = this.columnasFechas.length ? this.columnasFechas.length : (Math.floor(Math.random() * 3) + 4);
    this.generarColumnasFechas(cols);
    this.generarValoresAleatoriosForCuentas();
  }

  public async sucursalChange(sucClick: any) {
    for (const suc of this.sucursales) {
      if (sucClick !== 'consolidado' && suc.name === sucClick.name) {
        suc.check = true;
      } else {
        suc.check = false;
      }
    }

    if (sucClick === 'consolidado') {
      this.consolidado = !this.consolidado;
      this.sucursalSeleccionada = 'filtros.consolidado';
    } else {
      this.consolidado = false;
      this.sucursalSeleccionada = sucClick.name;
    }

    // Regenerar columnas usando el año seleccionado (selectedProjectionYear) o por defecto
    const cols = this.columnasFechas.length ? this.columnasFechas.length : (Math.floor(Math.random() * 3) + 4);
    this.generarColumnasFechas(cols);

    // Si no hay cuentas cargadas, intentar obtenerlas; si ya están, regenerar valores aleatorios
    if (!this.dataCuentaContable || this.dataCuentaContable.length === 0) {
      if (this.templateId) {
        // carga asíncrona de cuentas (mantendrá el skeleton si no hay datos)
        await this.getCuentasContables();
      }
    } else {
      this.generarValoresAleatoriosForCuentas();
    }
  }

  resetFilters() {
    for (const esc of this.escenarios) {
      esc.check = false;
    }
    this.todosEscenarios = true;
    this.escenarioSeleccionado = 'proyFinanciera.escenarioProyeccion.escenario';

    for (const suc of this.sucursales) {
      suc.check = false;
    }
    this.consolidado = true;
    this.sucursalSeleccionada = 'filtros.consolidado';
  }


  public exportarExcel() {
    if (this.dataCuentaContable.length === 0) {
      messages.infoMessageGraph(this.translate.instant('proyFinanciera.configCatalogo.confVacia'));
      return;
    }

    // Preparar encabezados
    const encabezado = [
      this.translate.instant('proyFinanciera.escenarioProyeccion.titTab1'), // Código
      this.translate.instant('proyFinanciera.escenarioProyeccion.titTab2'), // Descripción
      ...this.columnasFechas // Fechas dinámicas
    ];

    // Preparar datos - ahora usa cuentasJerarquicas completo
    const datos: any[] = [];
    this.prepararDatosExcelCompleto(this.cuentasJerarquicas, datos);

    // Configurar alineaciones
    const alineacion: string[] = [
      Aligment.RIGHT,  // Código
      Aligment.LEFT,   // Descripción
      ...this.columnasFechas.map(() => Aligment.RIGHT) // Valores numéricos
    ];

    // Configurar formatos
    const formatos: string[] = [
      FormatText.TEXT,    // Código
      FormatText.TEXT,    // Descripción
      ...this.columnasFechas.map(() => FormatText.NUMBER) // Formato número con comas
    ];

    // Generar título
    const titulo = `${this.translate.instant('menu.' + this.dataService.moduleSelect)} - ${this.translate.instant('menu.' + this.dataService.subModuleSelect)}`;
    const nombreArchivo = `Escenarios_Proyectados_${this.instSelecc.alias || 'Sin_Institucion'}`;

    // Llamar al servicio de Excel
    this.excelService.generateExcel(
      titulo,
      encabezado,
      datos,
      nombreArchivo,
      alineacion,
      formatos
    );
  }

  private prepararDatosExcelCompleto(cuentas: any[], datos: any[], nivel: number = 0) {
    for (const cuenta of cuentas) {
      // Agregar indentación según el nivel
      const indentacion = '  '.repeat(nivel);
      const fila = [
        cuenta.codigo,
        indentacion + cuenta.nombre,
        ...cuenta.valores
      ];

      datos.push(fila);

      // Si tiene hijos, agregarlos SIEMPRE (sin importar si está expandido)
      if (cuenta.hijos && cuenta.hijos.length > 0) {
        this.prepararDatosExcelCompleto(cuenta.hijos, datos, nivel + 1);
      }
    }
  }
}
